export default __webpack_public_path__ + "static/media/e-learning.3a2be89e.svg";